import { initialEditExperimentState } from 'modules/experiments/takeover/constants/experiment';
import { ActionTypes } from 'modules/experiments/takeover/ducks/actionTypes';
import {
  ExperimentAction,
  ExperimentState,
  OriginalExperimentState,
} from 'modules/experiments/takeover/types';

export const initialExperimentState: ExperimentState = {
  currentLocale: '',
  loading: false,
  error: false,
  data: initialEditExperimentState,
};

export const experimentReducer = (
  state = initialExperimentState,
  action?: ExperimentAction,
): ExperimentState => {
  switch (action?.type) {
    case ActionTypes.DRAWER_OPEN:
      return {
        ...state,
        loading: true,
        error: false,
        data: state.data,
      };

    case ActionTypes.EXPERIMENT_DATA_LOADED:
    case ActionTypes.DRAWER_OPEN_WITH_DATA: {
      const data = (action?.payload as OriginalExperimentState) || state.data;
      return {
        ...state,
        loading: false,
        error: false,
        data,
      };
    }

    case ActionTypes.UPDATE_EXPERIMENT_VARIANTS: {
      const variations =
        (action?.variations as OriginalExperimentState['variations']) || state.data.variations;
      return {
        ...state,
        data: {
          ...state.data,
          variations,
        },
      };
    }

    case ActionTypes.EXPERIMENT_DATA_ERRORED:
      return {
        ...state,
        loading: false,
        error: true,
        data: state.data,
      };

    case ActionTypes.UPDATE_EXPERIMENT_LOCALE: {
      const currentLocale = (action?.payload as string) || state.currentLocale;
      return {
        ...state,
        currentLocale,
      };
    }

    default:
      return state;
  }
};
